export const megabytesToBytes = (mb: number) => {
  return mb * 1024 ** 2;
};

export const bytesToMegabytes = (b: number) => {
  return Math.round(b / 1000 ** 2);
};
